<template>
  <v-card class="ma-4">
    <h3 class="mb-4">New Product(s) Added (WIP for giclees)</h3>
    <v-card-title>Print</v-card-title>
    <v-list v-if="savedProduct.printProduct" dense>
      <v-list-item>
        <v-list-item-content>SKU:</v-list-item-content>
        <v-list-item-content class="align-end">{{ savedProduct.printProduct.sku }}</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>Width:</v-list-item-content>
        <v-list-item-content class="align-end">{{ savedProduct.printProduct.gicleeWidth }} mm</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>Height:</v-list-item-content>
        <v-list-item-content class="align-end">{{ savedProduct.printProduct.gicleeHeight }} mm</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>Barcode:</v-list-item-content>
        <v-list-item-content class="align-end">
          <span>{{ savedProduct.printProduct.barCode}}
            <v-btn icon color="primary" @click.native="barcodeDownload(savedProduct.printProduct.barCode)">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </span>
          <vue-barcode style="display: none" class="v-clickable" ref="barcode" :value="savedProduct.printProduct.barCode" format="EAN13" height="30" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-card-title>Mounted Print</v-card-title>
    <v-list v-if="savedProduct.mountedProduct" dense>
      <v-list-item>
        <v-list-item-content>SKU:</v-list-item-content>
        <v-list-item-content class="align-end">{{ savedProduct.mountedProduct.sku }}</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>Width:</v-list-item-content>
        <v-list-item-content class="align-end">{{ savedProduct.mountedProduct.gicleeWidth }} mm</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>Height:</v-list-item-content>
        <v-list-item-content class="align-end">{{ savedProduct.mountedProduct.gicleeHeight }} mm</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>Mount Width:</v-list-item-content>
        <v-list-item-content class="align-end">{{ savedProduct.mountedProduct.gicleeMountedWidth }} mm</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>Mount Height:</v-list-item-content>
        <v-list-item-content class="align-end">{{ savedProduct.mountedProduct.gicleeMountedHeight }} mm</v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>Barcode:</v-list-item-content>
        <v-list-item-content class="align-end">
          <span>{{ savedProduct.mountedProduct.barCode}}
            <v-btn icon color="primary" @click.native="barcodeDownload(savedProduct.mountedProduct.barCode)">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </span>
          <vue-barcode style="display: none" class="v-clickable" ref="barcode" :value="savedProduct.mountedProduct.barCode" format="EAN13" height="30" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { svgToImgDownload } from '@/utilities/imageUtilities'
import VueBarcode from 'vue-barcode'

export default {
  props: {
    savedProduct: Object
  },
  components: {
    VueBarcode
  },
  methods: {
    barcodeDownload(sku) {
      const svg = document.querySelector(".vue-barcode-element");
      svgToImgDownload( svg, `${sku}-BARCODE.jpg` , 500, 200 )
    },
  }
}
</script>

